export default __webpack_public_path__ + "static/media/childrens-care-5.8eb35ca5.svg";